import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { useAuth } from '../../Contexts/AuthProvider';
import LayoutProvider from '../../Contexts/LayoutProvider';
import { GetCurrentUrl, mkRelativeUrl } from '../../utils/URL';
import MenuProvider, { useMenus } from './MenuProvider';
import MobileSidebarMenuPage from './SidebarMenu/MobileSidebarMenuPage';
import SidebarMenuPage from './SidebarMenu/SidebarMenuPage';
import pathLinks from './SidebarMenu/links';
import MobileHeaderPage from './WebHeader/MobileHeaderPage';
import WebHeaderPage from './WebHeader/WebHeaderPage';

function PageCont() {
    const { menuOpen } = useMenus();
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        if (location.pathname === '/') {
            navigate(mkRelativeUrl('/dashboard'));
        }
    }, [location, navigate]);

    useEffect(() => {
        if (isAuthenticated() === false) {
            const currentUrl = GetCurrentUrl();
            if (currentUrl !== '/login') {
                window.location.href = `/login/?url=${currentUrl}`;
            } else {
                navigate(mkRelativeUrl('/login'));
            }
        }
    }, [isAuthenticated, navigate]);

    // --exit if user is not authenticated
    if (isAuthenticated() === false) return null;

    return (
        <>
            <LayoutProvider>
                <WebHeaderPage layout="lg" />
                <MobileHeaderPage layout={['md', 'sm', 'xs', 'xxs']} />
            </LayoutProvider>

            <div className="flex flex-row h-full">
                <LayoutProvider>
                    <SidebarMenuPage links={pathLinks} layout="default" />
                    <MobileSidebarMenuPage links={pathLinks} layout={['md', 'sm', 'xs', 'xxs']} />
                </LayoutProvider>
                <div className={`page_cont ${menuOpen ? 'active' : ''}`}>
                    <Outlet />
                </div>
                <Tooltip id="myToolTip" style={{ zIndex: '9999999999' }} />
            </div>
        </>
    );
}

function Menus() {
    return (
        <MenuProvider>
            <PageCont />
        </MenuProvider>
    );
}

export default Menus;
